module.exports = __webpack_public_path__ + "static/jc04657-preparation-step-03-987544e43af6a877738b80ae70cc96e6.png";